import { render, staticRenderFns } from "./DonorList.vue?vue&type=template&id=ea34c00e&"
import script from "./DonorList.vue?vue&type=script&lang=ts&"
export * from "./DonorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports